export default "__VITE_ASSET__BgbLCIio__"